module.exports = __webpack_public_path__ + "img/47016de.png";